import React, { useContext } from "react";
import CountryConfigContext from "../CountryConfigContext";
import Badge from "./Badge";

const CheckTranslations = ({ value, checkTranslation, translations, disabled }) => {
  const {
    config: { languages },
  } = useContext(CountryConfigContext);

  const languagesConverted = languages.map((language) => {
    const find = translations.find(
      (translation) =>
        translation.locale === language.code && translation.key === value
    );
    if (find) {
      return { ...language, translated: true };
    }

    return language;
  });

  if (!value) {
    return null;
  }

  return (
    <div className="flex mt-2">
      {languagesConverted.map((l) => (
        <Badge
          disabled={disabled}
          onClick={() => {
            if (disabled) return;
            if (!l.translated) {
              checkTranslation({ locale: l.code, key: value });
            }
          }}
          key={l.id}
          type={l.translated ? "success" : "info"}
          text={l.code.toUpperCase()}
          classNames={disabled? 'cursor-not-allowed mr-2': l.translated ? "mr-2" : "cursor-pointer mr-2"}
        />
      ))}
    </div>
  );
};

export default CheckTranslations;
